export default __webpack_public_path__ + "static/media/4b93c54cf2cbc0cda5de848b8185686a.svg";